import styled from "styled-components";
import { device } from "../services/styles";

export const Flex = styled.div`
  display: flex;
  align-items: ${(props) => {
    switch (props.alignItems) {
      case "flex-start":
        return "flex-start";
      default:
        return "center";
    }
  }};
  flex-wrap: ${(props) => props.wrap || "nowrap"};
  flex-direction: ${(props) => props.direction || "row"};
  justify-content: ${(props) => {
    switch (props.justifyContent) {
      case "stretch":
        return "stretch";
      case "space-between":
        return "space-between";
      case "space-around":
        return "space-around";
      default:
        return "flex-start";
    }
  }};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns || "auto"};
  grid-gap: ${(props) => props.gap || "0"};
  ${(props) => props.columnGap && `column-gap: ${props.columnGap};`}
  ${(props) => props.rowGap && `row-gap: ${props.rowGap};`}
  align-items: ${(props) => props.alignItems || "flex-start"};
  @media ${device.tablet} {
    ${(props) => props.mdColumnGap && `column-gap: ${props.mdColumnGap};`}
    ${(props) =>
      props.mdTemplateColumns &&
      `grid-template-columns: ${props.mdTemplateColumns};`}
  }
  @media ${device.desktop} {
    ${(props) => props.lgColumnGap && `column-gap: ${props.lgColumnGap};`}
    ${(props) =>
      props.lgTemplateColumns &&
      `grid-template-columns: ${props.lgTemplateColumns};`}
  }
`;

export const Space = styled.div`
  margin-top: ${(props) => (props.y ? props.y : "0")}px;
  margin-left: ${(props) => (props.x ? props.x : "0")}px;
`;
